import { Page, PageFace } from 'ui/components/Page'
import { Panel, PanelFace } from 'ui/components/Panel'
import { BSABreadcrumbs } from 'ui/temp'
import { BSA_MODULE_PATH } from '~bank-bsa-reporting/constants'

import { PCTTable } from './components'

const ParsedCashTransactionList = () => (
  <Page
    face={PageFace.PRIMARY}
    title={<BSABreadcrumbs title="Parsed Cash Transactions" parentUrl={BSA_MODULE_PATH} parentTitle="BSA Reporting" />}
  >
    <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
      <PCTTable />
    </Panel>
  </Page>
)

export default ParsedCashTransactionList
